import LocalizedStrings from 'react-localization';

export let texts = new LocalizedStrings({
  al:{
      // MARK: - Prompt
      "prompt-add-contract" : "Plotësoni fushat për të shtuar një kontratë",
      "prompt-add-number" : "Plotësoni fushat për të shtuar një numër",       
      "prompt-add-code" : "Plotësoni fushat për të shtuar një kod",      
      "prompt-add-smartcard" : "Plotësoni fushat për të shtuar një smartkartë",      
      "prompt-add-car" : "Plotësoni fushat për të shtuar një mjet",       
      "prompt-choose-city" : "Zgjidhni qytetin",
      "prompt-choose-franchaise" : "Zgjidhni franshizën",         
      "prompt-more" : "Më shumë",      
      "prompt-partner" : "Partnerët",      
      "prompt-biometric-login" : "Hyni në llogarinë tuaj me %@",     
      "prompt-no-account" : "Nuk jeni klient EasyPay?",       
      "prompt-no-account-create" : "Krijoni një llogari",       
      "prompt-no-account-create-ott" : "Krijoni një llogari OTT",
      "prompt-easypay-agents" : "Pikat EasyPay",       
      "prompt-phone-validation" : "Vendosni kodin që ju është dërguar me SMS",      
      "prompt-email-validation" : "Klikoni link-un që ju është dërguar në adresën e e-mail-it.",     
      "prompt-favorite-comment" : "Vendosni një koment për %@.",       
      "prompt-favorite-save" : "Dëshironi ta ruani %@ për ta përdorur sërish?",      
      "prompt-p2p-amount" : "Vendosni vlerën që dëshironi të kërkoni.",        
      "prompt-from-date" : "Nga data",     
      "prompt-to-date" : "Në datën",       
      "prompt-upload-id" : "Ngarkoni një foto të mjetit të identifikimit.",        
      "prompt-transfer-info" : "Vendosni të dhënat e transfertës.",           
      "prompt-accept-transfer" : "Pranoni një kërkesë për dërgesë parash.",            
      "prompt-fill-fields" : "Plotësoni fushat për të kërkuar",          
      "prompt-choose-search-method" : "Zgjidhni metodën e kërkimit",  
      "prompt-choose-insurance-type" : "Zgjidhni llojin e siguracionit",          
      "prompt-choose-account-type" : "Zgjidhni llogarinë tuaj",             
      "prompt-choose-taxes" : "Zgjidhni taksat që doni të paguani",           
      "prompt-choose-installments" : "Zgjidhni këstet që doni të paguani",           
      "prompt-set-topup-amount" : "Vendosni vlerën e rimbushjes",        
      "prompt-offer-number" : "Jepni numrin ku dëshironi ofertën ",             
      "prompt-want-offer" : "Dëshironi ofertë?",          
      "prompt-choose-contract-type" : "Zgjidhni tipin e kontratës",          
      "prompt-choose-product" : "Zgjidhni produktin që dëshironi",        
      "prompt-change-password" : "Plotësoni fushat për të ndryshuar fjalëkalimin",                 
      "prompt-cif-code" : "Kodi CIF",        
      "prompt-accept-terms" : "Konfirmoj që kam lexuar dhe pranoj %@ e EasyPay.",            
      "prompt-confirmation-code" : "Kodi i konfirmimit",               
      "prompt-insert-confirmation-code" : "Vendosni kodin e konfirmimit",           
      "prompt-buy-tshirt" : "Dëshironi një bluzë?",           
      "prompt-search-with-phone" : "Kërkoni me numër telefoni",             
      "prompt-search-with-client-code" : "Kërkoni me kod klienti",         
      "prompt-search-with-contract-code" : "Kërkoni me kod kontrate",               
      "prompt-search-with-serie" : "Kërkoni me numër serial",     
      "prompt-search-with-date" : "Kërko me datë"  ,       
      "prompt-contract-code" : "Kod kontrate",      
      "prompt-numbers" : "Numrat",      
      "prompt-invoice-date" : "Data e faturës",   
      "prompt-invoice-number" : "Numër Fature",      
      "prompt-phone-verification" : "Verifikim i numrit të telefonit",          
      "prompt-copy" : "Kopjoni",         
      "prompt-save-contract" : "Ruani kontratën për ta ripërdorur sërish",          
      "propmt-details" : "Detajet",        
      "propmt-statements" : "Veprimet e fundit",            
      "propmt-new-card-transaction-card-on-file" : "Kryeni pagesën me një kartë të re",  
      "prompt-create-request" : "Krijo kërkesën",
      "propmt-create-money-request" : "Krijo një kërkesë për para",  
      "prompt-send-money" : "Dërgo Para",
      "prompt-send-money-to" : "Dërgo para tek:",
      "prompt-choose-search-method" : "Zgjidh menyrën e kërkimit",  
      "prompt-choose-type" : "Zgjidh tipin",
      "prompt-choose-city" : "Zgjidh qytetin",
      "prompt-change-data" : "Ndrysho të dhënat",
      "prompt-topup-card" : "Rimbush llogarinë me kartë",
      "prompt-save-card" : "Ruaj këtë kartë",
      "prompt-send-email": "Dërgo në E-mail",
      "prompt-download-pdf": "Shkarko PDF",
      "prompt-open-graphs": "Shiko grafikët",
      "prompt-how-it-works": "Si funksionon?",
      "prompt-choose-payment-plan": "Zgjidh planin e pagesës",
      "prompt-choose-country": "Zgjidh shtetin",
      "prompt-choose-region": "Zgjidh rajonin",
      "prompt-choose-packet": "Zgjidh paketën",
      "prompt-included-countries": "Shtetet e përfshira",
      "prompt-volume": "Volumi",
      "prompt-duration": "Kohëzgjatja",
      "prompt-esim-compatibility": "Konfirmoni që pajisja juaj është e përputhshme me eSim",
  
      // MARK: - Button
      "button-back" : "Kthehuni",       
      "button-continue" : "Vazhdoni",           
      "button-login" : "Hyni në llogari",         
      "button-login-short" : "Hyni",       
      "button-activate" : "Aktivizoni",         
      "button-not-now" : "Jo tani",       
      "button-ok" : "OK",       
      "button-confirm" : "Konfirmoni",     
      "button-cancel" : "Anulloni",      
      "button-read": "Lexoni",     
      "button-yes" : "Po",       
      "button-no" : "Jo",   
      "button-view" : "Shikoni",      
      "button-later" : "Më vonë",      
      "button-update" : "Përditësoni",      
      "button-delete" : "Fshini",       
      "button-choose" : "Zgjidhni",       
      "button-reset" : "Rivendosni",     
      "button-done" : "Mbyllni",       
      "button-create-account" : "Krijoni një llogari falas",        
      "button-have-account" : "Kam një llogari",      
      "button-take-photo" : "Fotografoni",     
      "button-choose-photo" : "Përzgjidhni",        
      "button-logout" : "Dilni",         
      "button-p2p-request" : "Krijoni kërkesën",       
      "button-register" : "Regjistrohuni",     
      "button-scan" : "Skanoni",        
      "button-upload" : "Ngarkoni",        
      "button-click-for-more" : "Klikoni për më tepër",       
      "button-transfer" : "Transferoni",         
      "button-start" : "Nisni",        
      "button-load-offers" : "Ngarkoni ofertat",       
      "button-account-activity" : "Aktiviteti i llogarisë",          
      "button-contact-us" : "Na kontaktoni",       
      "button-change-password" : "Ndryshoni fjalëkalimin",    
      "button-change" : "Ndryshoni",     
      "button-forgot-password" : "Kam harruar fjalëkalimin",      
      "button-forgot-username" : "Kam harruar përdoruesin",     
      "button-forgot-data" : "Keni harruar të dhënat?",       
      "button-accept" : "Pranoj",     
      "button-account-topup" : "Rimbushni llogarinë",      
      "button-send-money" : "Dërgoni para",      
      "button-receive-money" : "Merrni para",    
      "button-topup-card" : "Rimbushni me kartë",         
      "button-topup-agents" : "Pikat EasyPay",      
      "button-register-self" : "Regjistroni veten tuaj",      
      "button-register-others" : "Regjistroni dikë tjetër",        
      "button-pay-bill" : "Paguani faturat",      
      "button-retry" : "Riprovoni",     
      "button-send" : "Dërgoni para",      
      "button-finish-registration" : "Përfundoni regjistrimin",
      "button-add-card" : "Shto kartë",
      "button-top-up-with-another-card" : 'Vazhdoni pa ruajtur karten',
      "button-top-up-card" : "Rimbushni",  
      "button-convert" : "Konverto",
      "button-search" : "Kërko",
      "button-add-local-obligations" : "Shto detyrime vendore",
      "button-confirm" : "Konfirmoni",
      "button-sign" : "Firmosni",
      "button-see-references": "Shiko referimet",
      "button-generate": "Gjenero",
      "button-share": "Shpërndaj",
      "button-invite-friends": "Fto miqtë",
      "button-topup-account": "Rimbush llogarinë",
      "button-continue-without-reference": "Vazhdo pa kod referimi",
      "button-confirm-code": "Konfirmo kodin",
      "button-do-actions": "Kryej veprimet",
      "button-personal": "Personale",
      "button-non-personal": "Jo personale",
      "button-donate" : "Dhuroni",
      "button-country" : "Shtetet",
      "button-region" : "Regjionale",
      "button-global" : "Globale",
  
      // MARK: - Title
      "title-ups" : "Ups...",      
      "title-welcome" : "Përshëndetje!",      
      "title-registration-email" : "Adresa juaj e e-mail",      
      "title-registration-email-business" : "Adresa e-mail e biznesit",     
      "title-registration-nipt" : "NIPT i biznesit",    
      "title-registration-password" : "Krijoni një fjalëkalim",      
      "title-registration-idNumber" : "Numri personal i identifikimit",       
      "title-registration-idNumber-business" : "Numri personal i identifikimit të administratorit",           
      "title-registration-expiryDate" : "Data e skadencës së mjetit të identifikimit",       
      "title-registration-expiryDate-business" : "Data e skadencës së mjetit të identifikimit të administratorit",     
      "title-registration-uploadIdPhoto" : "Ngarkoni një foto të mjetit <br/> të identifikimit",     
      "title-registration-city" : "Vendbanimi",     
      "title-registration-address" : "Adresa",     
      "title-phone-verification": "Verifikimi i numrit të telefonit",    
      "title-registration-birthdate" : "Datëlindja",    
      "title-registration-business-name" : "Emri tregtar i regjistruar i biznesit",      
      "title-registration-gender" : "Gjinia",     
      "title-registration-address-business" : "Adresa e selisë qendrore",    
      "title-registration-fathers-name-basic" : "Emri i babait",     
      "title-confirm-transaction" : "Konfirmoni transaksionin në \nnumër: %@ me vlerë: %@", 
      "title-confirm-offer" : "Konfirmoni ofertën: %@",    
      "title-id-info" : "Të dhënat e kartës",       
      "title-history" : "Historiku",     
      "title-utilities" : "Pagesat",      
      "title-favorite" : "Të preferuarat",      
      "title-search" : "Kërkoni", 
      "title-get-prim" : "Merni Primin",    
      "title-choose-prim" : "Zgjidhni Primin", 
      "title-more" : "Më tepër",     
      "title-offer-details" : "Detajet e ofertës",      
      "title-pay" : "Paguani",      
      "title-faq" : "Pyetje të shpeshta",          
      "title-transfer" : "Transferoni",         
      "title-topup" : "Rimbushni",        
      "title-new-service" : "Shërbim i ri",         
      "title-buy" : "Blini",       
      "title-activate-biometric-login" : "Hyni me %@?",         
      "title-biometric-login" : "Hyni me %@",        
      "title-error" : "Problem",       
      "title-warning" : "Vëmendje",        
      "title-success" : "Sukses",      
      "title-home" : "Kreu",      
      "title-contracts" : "Kontratat",         
      "title-p2p" : "EasyTransfer",      
      "title-beneficiaries" : "Marrësit e mi",         
      "title-choose-date" : "Zgjidhni datën",          
      "title-new-version" : "Version i ri",       
      "title-events" : "Eventet",        
      "title-push-notifications" : "Njoftime me Push notifications",          
      "title-email-notifications" : "Njoftime me e-mail",       
      "title-abort-registration" : "Dëshironi ta ndërprisni regjistrimin?",      
      "title-phone-validation" : "Verifikim i numrit të telefonit",      
      "title-email-validation" : "Verifikim i e-mail-it",      
      "title-others" : "Të tjera",          
      "title-favorite-save" : "Ruani %@ për ta ripërdorur sërish",      
      "title-favorite-save-short" : "Ruani",      
      "title-client-codes" : "Kodet",      
      "title-transactions" : "Transaksionet",         
      "title-gross-amount-shown" : "Totali i shfaqur",          
      "title-balance" : "Balanca ime",         
      "title-filter" : "Filtroni datat",          
      "title-categories" : "Kategoritë",           
      "title-new" : "E re!",         
      "title-months-count" : "Muaj:",         
      "title-contract" : "Kontratë",        
      "title-phone-number-short" : "Numër telefoni",          
      "title-serie" : "Serial",        
      "title-product" : "Produkti",         
      "title-payments" : "Pagesa",       
      "title-client-code" : "Kod klienti",       
      "title-document-number" : "Numër dokumenti",           
      "title-my-loan" : "Kredia është në emrin tim",         
      "title-tickets" : "Gjobat",         
      "title-nuis" : "NIPT",        
      "title-administrator" : "Administrator",             
      "title-invoice" : "Faturë",            
      "title-agreement-act" : "Akt marrëveshje",         
      "title-car-plate" : "Targë",         
      "title-reset-password" : "Kam harruar fjalëkalimin.",          
      "title-notifications" : "Njoftimet",          
      "title-account" : "Llogaria",          
      "title-my-account" : "Llogaria ime",            
      "title-full-name" : "Emri i plotë",           
      "title-ecommerce" : "E-commerce",          
      "title-developed-by" : "Developed by:   EasyPay",             
      "title-topup-bank" : "Rimbushni nga llogaria bankare",           
      "title-topup-card" : "Rimbushni me kartë",          
      "title-toup-agent" : "Nuk keni një llogari bankare?",            
      "title-change-password" : "Ndryshoni fjalëkalimin",           
      "title-menu" : "Menu",           
      "title-terms-update" : "Termat dhe kushtet janë përditësuar",           
      "title-account-number" : "Numri i llogarisë",        
      "title-transaksion" : "Transaksion",        
      "title-language" : "Gjuha",          
      "title-activate-biometric" : "Aktivizoni të dhënat biometrike",          
      "title-deactivate-biometric" : "Fshini të dhënat biometrike",             
      "title-current-offer" : "Oferta aktuale",              
      "title-forgot-credentials" : "Keni harruar të dhënat?",            
      "title-complete-registration" : "Përfundoni regjistrimin në EasyPay",            
      "title-skip-registration-step" : "Dëshironi ta tejkaloni këtë hap?",          
      "title-bank-transfer" : "Rimbushni me transfertë bankare",           
      "title-profile" : "Profili",         
      "title-terms-and-conditions" : "Termat dhe Kushtet",           
      "title-all-rights" : "Të gjitha të drejtat e rezervuara",           
      "title-change-password-exp" : "Vendosni përdoruesin",         
      "title-field-number" : "Numri",           
      "title-field-amount" : "Vlera",          
      "title-obligations-list" : "Lista e detyrimeve",        
      "title-my-cards" : "Kartat e mia",  
      "title-no-cards" : "Ju nuk keni karta te ruajtura ne EasyPay!",
      "title-offers": "Oferta",
      "title-transaction-details": "Detajet e transaksionit",
      "title-transaction-graph": "Grafiku për transaksionet e kryera",
      "title-invite-friend" : "Fto një mik",
      "title-gain-500L": "Përfito 500 ALL \n EasyPay kredit për çdo referim të suksesshëm!",
      "title-you-gain": "Ju fitoni:",
      "title-no-references": "Asnjë referim i kryer",
      "title-asking-referedCode": "Keni një kod referimi nga një mik?",
      "title-invited-friends": "Miqtë e ftuar",
      "title-500All": "500 ALL per cdo mik!",
      "title-win-500All": "Fito 500 ALL!",
      "title-reference-loan": "Numër reference kredie",
      "title-is-personal-loan": "A është kredi personale?",
      "title-client-id": "ID e klientit",
      "title-client": "Klienti",
      "title-loan-reference": "Referenca e kredisë",
      "title-installment-amount": "Vlera e kestit",
      "title-rollover-amount": "Vlera e shtyrjes",
      "title-pay-other-amount": "Paguaj vlerë tjetër",
      "title-select-payment": "Zgjidh pagesën",
      "title-donation-value": "Vlera e dhurimit",
      "title-donate-anonymus": "Dhurim anonim?",
      "title-thanks": "Faleminderit!",
      "title-package-details": "Detajet e paketës",
      
  
      //MARK: - Message
      "message-app-crashed" : "Diçka nuk shkoi mirë në aplikacion. Ju mund të kontaktoni në klient@easypay.al.\n\nFaleminderit për mirëkuptimin!\n\nEasyPay",         
      "message-resend-otp" : "Klikoni këtu për të ridërguar kodin",         
      "message-resend-email" : "Klikoni këtu për të ridërguar e-mail-in",       
      "message-under-age" : "Ju jeni nën moshën e lejuar!",          
      "message-questionaire-request-failed" : "Përgjigjja nuk u dërgua me sukses",            
      "message-scan-result-invalid" : "Kodi i skanuar nuk është i saktë",              
      "message-inactive-service" : "Ky shërbim nuk është aktiv për këtë përdorues.",         
      "message-location-denied" : "Lejoni aksesin në vendndodhjen tuaj për të shfaqur listën e pikave EasyPay.",         
      "message-location-not-available" : "Vendndodhja nuk mund të përcaktohet.",          
      "message-locked-service" : "Ky shërbim nuk është aktiv për këtë përdorues.",         
      "message-new-old-password-match" : "Fjalëkalimi i vjetër përputhet me fjalëkalimin e ri! Krijoni një fjalëkalim tjetër ",        
      "message-new-service" : "Ky sherbim do të vijë së shpejti në aplikacion!",        
      "message-password-rules" : "a. Fjalëkalimi nuk duhet të përmbajë emrin/mbiemrin tuaj, emrin e firmës/kompanisë tuaj, apo emrin e përdoruesit (username) !\n\nb. Fjalëkalimi duhet të ketë gjatësi minimale prej 6 karakteresh.\n\nc. Të përbëhet nga shkronja të vogla e të mëdha, numra dhe karaktere speciale si (!@#$%^&*()_+-{}<>?|:[],./)\n\nd. Rekomandohet që në çdo ndryshim fjalëkalimi të përdorni një fjalëkalim që nuk e keni përdorur më parë.\n\ne. Shembull i një fjalëkalimi të saktë: Au@Oz1!",     
      "message-p2p-save-transfer" : "Ruani marrësin për t'i dërguar para herë të tjera.",      
      "message-p2p-wrong-username" : "Përdoruesi nuk është i vlefshëm!",         
      "message-direct-debit-fee" : "* Komisioni për këtë vlerë është %.2f %@.",           
      "message-general-error" : "Diçka nuk shkoi mirë! Ju lutemi të provoni përsëri!",          
      "message-pull-to-refresh" : "Uleni ekranin për rifreskim",      
      "message-activation-failed" : "Aktivizimi i %@ dështoi! Ju lutemi të provoni përsëri!",         
      "message-blocked-user" : "Përdoruesi është i bllokuar! Kontaktoni EasyPay për më shumë informacion!",            
      "message-request-timed-out" : "Kërkesa nuk u arrit të plotësohej. Ju lutemi të provoni përsëri.",        
      "message-expired-password" : "Fjalëkalimi juaj ka skaduar! Ju duhet të ndryshoni fjalëkalimin!",        
      "message-expired-token" : "Sesioni juaj ka skaduar! Ju lutemi të hyni përsëri!",       
      "message-first-time-password" : "Ndryshoni fjalëkalimin tuaj të përkohshëm me një fjalëkalim të ri dhe të sigurt!",       
      "message-locked-user" : "Përdoruesi është i kyçur sepse ka vendosur 5 herë fjalëkalim të gabuar!\nRivendosni fjalëkalimin dhe provoni përsëri !",         
      "message-otp-not-generated" : "Kodi i konfirmimit nuk u krijua. Klikoni ridërko kodin.",          
      "message-otp-not-sent" : "Kodi i konfirmimit nuk u dërgua.",          
      "message-otp-sent" : "Kodi i konfirmimit është dërguar. Ju mund të riprovoni pas disa sekondash.",       
      "message-password-changing-failed" : "Ndërrimi i fjalëkalimit dështoi !\n Ju lutemi të provoni përsëri !",       
      "message-uninitialized-token" : "Sesioni nuk mund të inicializohet! Ju lutemi të provoni përsëri!",     
      "message-unverified-user" : "Të dhënat e përdoruesit nuk janë të verifikuara!",       
      "message-user-token-not-found" : "Nuk u gjet një sesion për këtë përdorues!",        
      "message-weak-password" : "Fjalëkalimi që vendosët nuk plotëson kriteret e sigurisë. Shikoni informacionin e mëposhtëm në lidhje me kriteret e fjalëkalimeve .",         
      "message-wrong-password" : "Fjalëkalimi që vendosët është i gabuar !",          
      "message-welcome" : "Mirë se erdhët në EasyPay!",        
      "message-event-expired" : "Ky event ka përfunduar",      
      "message-jailbreak" : "Kjo pajisje është bërë 'jailbreak'. Aplikacioni EasyPay nuk suporton pajisje të tilla. Na vjen keq për shqetësimin.",          
      "message-new-version-available" : "Një version i ri i aplikacionit ofrohet në App Store. Ju lutemi të përditësoni aplikacionin për të përfituar nga shërbimet më të fundit.",             
      "message-onboarding-clients-trust-us" : "Mijëra klientë ia besojnë pagesat e tyre çdo ditë EasyPay-it!",        
      "message-p2p-code-generated" : "Një klient EasyPay mund të skanojë këtë kod nga menuja \"Dërgo para\" e aplikacionit për të pranuar kërkesën tuaj.",      
      "message-join-revolution" : "Bëhuni pjesë e revolucionit!",        
      "message-automatic-id-scan" : "Përshpejtoni regjistrimin me anë të skanimit automatik të ID.",      
      "message-topup-bank" : "Lidhni llogarinë bankare me EasyPay dhe rimbushni shumën që dëshironi.",      
      "message-topup-card" : "Rimbushni llogarinë me kartë debiti ose krediti, pa komision.",       
      "message-topup-agent" : "Rimbushni llogarinë pranë pikave tona.",               
      "message-topup-card-explain" : "Ju mund të rimbushni llogarinë tuaj me kartë krediti ose debiti të lëshuar nga cilado bankë dhe të aktivizuar për pagesa online.",           
      "message-bank-not-linked" : "Ju nuk keni lidhur llogarinë tuaj bankare me EasyPay.",       
      "message-warning-union-bank-not-linked" : "Paraqituni pranë degës më të afërt Union Bank për të firmosur kontratën duke u dhënë kodin e mëposhtëm",       
      "message-warning-uba-bank-not-linked" : "Paraqituni pranë degës më të afërt UBA për të firmosur kontratën, e cila i jep të drejtën EasyPay të prekë balancën",     
      "message-bank-not-linked-bkt" : "Paraqituni pranë degës më të afërt BKT për të firmosur kontratën \"E-Collection\" për individ. Kjo i jep të drejtë EasyPay të prekë balancën me pëlqimin tuaj.",      
      "message-bank-not-linked-confirm-cif" : "Pasi të firmosni kontratën, konfirmoni numrin e klientit (kodin CIF) të llogarisë suaj bankare.",        
      "message-bank-link-pending" : "Brenda 48 orëve do të kryhet verifikimi i të dhënave tuaja.\n Për çdo problem apo paqartësi kontaktoni EasyPay.",
      "message-request-pending" : "Ju do të kontaktoheni nga skuadra EasyPay brenda 48 orëve",     
      "message-request-sent" : "Kërkesa juaj u dërgua me sukses!",     
      "message-bank-link-pending-title": "Të dhënat tuaja po konfirmohen",        
      "message-confirm-logout" : "Jeni të sigurt që dëshironi të dilni nga llogaria?",          
      "message-confirm-transaction-general": "Jeni të sigurt që dëshironi ta kryeni këtë veprim?",       
      "message-accept-terms" : "Ju duhet të pranoni versionin e ri të Termave dhe Kushteve për të vazhduar.",        
      "message-my-location" : "Vendndodhja ime",         
      "message-choose-option" : "Ju lutemi të zgjidhni një opsion",        
      "message-no-favorites" : "Ju nuk keni rekorde te ruajtura",        
      "message-are-you-student" : "Jeni student?",          
      "message-vodafone-pay-invoice-rule" : "Ju duhet të zgjidhni faturën e parë për të vazhduar",       
      "message-choose-account" : "Zgjidhni një llogari",       
      "message-delete-bank-account" : "Dëshironi të fshini llogarinë?",         
      "message-forgot-credential" : "Na ndodh të gjithëve. Ju lutemi të plotësoni të dhënat për të rikthyer profilin tuaj EasyPay",        
      "message-biometric-saved-successfully" : "Të dhënat biometrike u ruajtën me sukses!",         
      "message-complete-registration" : "Për të aksesuar të gjitha benefitet e llogarisë suaj në EasyPay, ju duhet të përfundoni procesin e regjistrimit",            
      "message-subtitle-registration": "Hidhni hapin e parë drejt lehtësive duke zgjedhur një nga llojet e llogarive më poshtë",       
      "message-subtitle-phone-verification" : "Vendosni kodin që ju është dërguar me SMS",
      "message-subtitle-phone-verification-top-up" : "Vendosni kodin që ju është dërguar me e-mail",        
      "message-subtitle-topup-bank-transfer" : "Rimbushni llogarinë tuaj EasyPay me anë të transfertës bankare.",
      "message-invalid-contract-number" : "Shtoni kontratën",   
      "message-invalid-contract-name" : "Shtoni emrin e kontratës",          
      "message-resend-otp-timer" : "Ju mund të ridërgoni kodin në",    
      "message-resend-email-timer" : "Ju mund të ridërgoni e-mail-in në",
      "message-invalid-field-data" : "Shtoni fushën", 
      "message-fill-field" : "Kjo fushë duhet plotësuar",
      "message-cannot-save-contracts" : "Ruatja e kontratave nuk është e disponueshme në këtë shërbim",
      "message-no-saved-contracts" : "Ju nuk keni kontrata te ruajtura ne EasyPay!",
      "message-ask-confirmation" : "Jeni te sigurt qe doni ta kryeni kete veprim?",
      "message-exchange-contact" : "Për këmbim valutor me kursin e shfaqur ose për kurs preferencial për shuma të mëdha, kontaktoni në:",  
      "message-welcome" : "Tashmë ju jeni pjesë e revolucionit!",
      "message-welcoming-info" : " Ju mund të përfitoni nga shërbimet digjitale të EasyPay. \n Kryeni pagesa dhe dërgoni para në kohë reale tek një tjetër klient i EasyPay.",
      "message-complete-registration" : "Për të aksesuar të gjitha benefitet e llogarisë tuaj në EasyPay, ju duhet të përfundoni procesin e regjistrimit",
      "message-cannot-read-id" : "Ndodhi një gabim në leximin e kartës.",
      "message-cannot-scan-face" : "Ndodhi një gabim në skanimin e fytyrës",
      "message-id-mismatch" : "Mjeti i identifikimit i vendosur nuk është i saktë, ju lutem vendosni  mjetin e identifikimit sipas kërkesës",
      "message-uanataca-id-mismatch" : "Ka një problem me përputhjen e kartës së identitetit me atë qe ekziston ne sistemin tonë. Ju lutem kontaktoni client@easypay.al",
      "message-held-amount": "është shuma që do të mbahet nga llogaria juaj EasyPay.",
      "message-thanks-for-donation": "Me mbështetjen dhe dhurimet tuaja ju ndihmoni fëmijët dhe të rinjtë të përfshirë në programet tona. ",  
  
      //MARK: No
      "message-no-bill" : "Nuk ka detyrime për t'u paguar",         
      "message-no-id-uploaded" : "Ju nuk keni ngarkuar një mjet identifikimi në llogarinë tuaj! Dërgoni një kopje të mjetit të identifikimit në info@easypay.al dhe provoni përsëri !",           
      "message-no-invoices" : "Nuk ka detyrime për t'u paguar",       
      "message-no-offer-chosen" : "Zgjidhni një ofertë.",          
      "message-no-offers" : "Nuk u arrit të merren ofertat. Provoni përsëri.",        
      "message-no-product-chosen" : "Zgjidhni një produkt.",         
      "message-no-ticket" : "Gjoba nuk gjendet në sistem.",        
      "message-no-tickets" : "Nuk ka gjoba për t'u paguar",       
      "message-new-confirm-password-no-match" : "Fjalëkalimi i ri nuk përputhet !",        
      "message-no-transactions-in-period" : "Nuk është kryer asnjë transaksion në këtë periudhë.",          
      "message-no-transaction-found" : "Nuk u gjet asnjë transaksion",         
      "message-no-transactions" : "Ju nuk keni kryer akoma asnjë transaksion.",              
      "message-no-internet" : "Mungon lidhja e internetit.",          
      "message-no-camera-access" : "EasyPay nuk ka akses te kamera.",           
      "message-no-photos-access" : "EasyPay nuk ka akses te fotot tuaja.",        
      "message-p2p-no-saved-transfers" : "Ju nuk keni asnjë marrës të ruajtur.",        
      "message-vodafone-account-topup" : "Rimbushni numrin dhe aktivizoni oferta",        
      "message-vodafone-pay-bill" : "Paguani faturat vetëm me 1 klikim",        
      "message-faq-not-found" : "Nuk po gjen pyetjen që po kërkoje?",       
      "message-answer-not-found" : "Nuk po gjen përgjigjjen që po kërkoje?",       
      "message-subtitle-reset-password" : "Plotësoni fushën më poshtë. Do të njoftoheni me e-mail për fjalëkalimin e ri",            
      "message-confirm-transaction" : "Jeni të sigurtë që doni ta konfirmoni këtë transaksion",
      "message-no-offers-disponible" : "Nuk ka paketa të disponueshme",
      "message-no-country-found" : "Nuk u gjet asnjë shtet",             
  
      //MARK: Empty
      "message-empty-new-password" : "Fjalëkalimi i ri është bosh!",        
      "message-empty-old-password" : "Fjalëkalimi i vjetër është bosh!",         
      "message-empty-confirm-password" : "Fjalëkalimi i konfirmimit është bosh!",           
      "message-empty-comment" : "Fusha Koment është plotësuar gabim.",          
      "message-empty-city" : "Zgjidhni një qytet!",          
      "message-empty-field" : "Ju lutemi të plotësoni fushën",           
      "message-complete-fields" : "Ju lutemi të plotësoni të gjitha fushat",           
      "message-client-code-empty-list" : "Ju nuk keni asnjë kod të regjistruar.",         
      "message-smartkartat-empty-list" : "Ju nuk keni asnjë smartkartë të regjistruar.",         
      "message-cars-empty-list" : "Ju nuk keni asnjë mjet të regjistruar.",       
      "message-local-code-empty-list" : "Ju nuk keni asnjë kod të regjistruar.",        
      "message-installment-code-empty-list" : "Ju nuk keni asnjë kod të regjistruar.",        
      "message-contracts-empty-list" : "Ju nuk keni asnjë kontratë të regjistruar.",       
      "message-numbers-empty-list" : "Ju nuk keni asnjë numër të regjistruar.",        
  
      //MARK: Success
      "message-update-id-info-success" : "Të dhënat e mjetit të identifikimit u ngarkuan me sukses!",       
      "message-upgrade-account-success" : "Llogaria juaj u ndryshua me sukses!",        
      "message-email-resend-success" : "E-mail-i u ridërgua me sukses!",        
      "message-otp-resend-success" : "Kodi u ridërgua me sukses!",       
      "message-success-register" : "Regjistrimi përfundoi me sukses!",      
      "message-success-change-passowrd" : "Ndryshimi i fjalëkalimit u krye me sukses !",      
      "message-success-reset-password" : "Në e-mail ju është dërguar një link konfirmues për ndryshimin e fjalëkalimit. Ju lutemi të kontrolloni kategoritë Spam/Junk.",      
      "message-success-trx" : "Transaksioni u krye me sukses!",      
      "message-success-offer" : "Oferta u krye me sukses!",      
      "message-success-upload" : "Ngarkimi i të dhënave u krye me sukses!",      
      "message-invoice-details" : "Detajet e faturës",      
      "message-saved-success" : "Të dhënat u ruajtën me sukses",      
      "message-iban-copied-success" : "IBAN-i u kopjua",       
      "message-success-forgot-data": "Aplikimi juaj u krye me sukses. Ju do të kontaktoheni nga stafi ynë sapo kërkesa juaj të përpunohet!",          
      "message-credit-card-deleted" : "Karta e zgjedhur u fshi me sukses",          
      "message-credit-card-added" : "Karta juaj u shtua me sukses", 
      "message-credit-top-up-successfull" : "Rimbushja u krye me sukses", 
      "message-notification-change-successfull" : "Ndryshimi u krye me sukses",
      "message-notification-get-cards-successfull": "Veprimi u krye me sukses",
      "email-sent-success": "Email-i u dërgua me sukses!",
  
      // MARK: Invalid
      "message-invalid-topup-value" : "Vlera e rimbushjes nuk është e saktë!",       
      "message-invalid-contract" : "Kontrata nuk është e vlefshme.",       
      "message-invalid-client-code" : "Kodi nuk është i vlefshëm.",       
      "message-invalid-local-code" : "Kodi nuk është i vlefshëm.",      
      "message-invalid-chase-no" : "Shasia nuk është e vlefshme.",      
      "message-invalid-plate" : "Targa nuk është e vlefshme. ",      
      "message-invalid-date" : "Datat nuk janë të sakta.",      
      "message-invalid-image" : "Ju duhet të ngarkoni një foto të mjetit tuaj të identifikimit.",      
      "message-invalid-image-size" : "Fotoja e zgjedhur tejkalon përmasat e lejuara.",     
      "message-invalid-image-ext" : "Fotoja e zgjedhur nuk ka formatin e duhur.",      
      "message-invalid-username" : "Emri i përdoruesit nuk është plotësuar saktë!",      
      "message-invalid-password" : "Fjalëkalimi nuk plotëson kriteret e gjatësisë dhe kompleksitetit!",      
      "message-invalid-new-password" : "Fjalëkalimi i ri nuk plotëson kriteret e gjatësisë dhe kompleksitetit!",      
      "message-invalid-old-password" : "Fjalëkalimi i vjetër nuk plotëson kriteret e gjatësisë dhe kompleksitetit!",      
      "message-invalid-temp-password" : "Fjalëkalimi i përkohshëm nuk plotëson kriteret e gjatësisë dhe kompleksitetit!",      
      "message-invalid-sc" : "Numri i smartkartës nuk është i saktë.",      
      "message-invalid-serial" : "Seriali nuk është i vlefshëm.",      
      "message-invalid-administrator" : "Administratori nuk është plotësuar saktë.",      
      "message-invalid-nuis" : "NIPT-i nuk është plotësuar saktë.",      
      "message-invalid-installment-code" : "Kodi i kredisë nuk është i vlefshëm.",      
      "message-invalid-token" : "Sesioni juaj nuk është më i vlefshëm!",      
      "message-invalid-role" : "Përdoruesi nuk ka rolin e përshtatshëm !",        
      "message-invalid-credentials" : "Kredencialet nuk janë të vlefshme!",       
      "message-invalid-phone-format" : "Numri i telefonit nuk është i vlefshëm! Numri duhet të fillojë me 67 | 68 | 69!",         
      "message-invalid-phone" : "Numri i telefonit nuk është i vlefshëm!",       
      "message-invalid-id-no-format" : "Numri i ID-së nuk është në formatin e duhur. Formati është A12345678A.",       
      "message-invalid-id-no" : "Numri personal nuk është i saktë.",      
      "message-invalid-username" : "Ky përdorues nuk është i vlefshëm !",      
      "message-invalid-cif-code" : "Ky numër CIF nuk është i vlefshëm !",      
      "message-invalid-sum" : "Shuma nuk duhet të jetë më e vogel se 100 Lekë dhe më e madhe se 20000 Lekë!",      
      "message-invalid-otp" : "Kodi i konfirmimit nuk është i saktë!",       
      "message-invalid-date-format" : "Plotësoni datat në formatin e duhur!",        
      "message-invalid-expiry-date" : "Data e skadencës nuk është e saktë",       
      "message-invalid-email" : "E-mail-i nuk është i saktë",      
      "message-invalid-full-name" : "Vendosni emrin tuaj të plotë.",      
      "message-invalid-password-length" : "Fjalëkalimi duhet të jetë 6 - 20 karaktere i gjatë.",      
      "message-password-not-matches" : "Fjalëkalimet nuk përputhen",       
      "message-invalid-password-no-number" : "Fjalëkalimi duhet të përmbajë të paktën një numër.",       
      "message-invalid-password-no-lowercase" : "Fjalëkalimi duhet të përmbajë të paktën një shkronjë të vogël.",       
      "message-invalid-password-no-uppercase" : "Fjalëkalimi duhet të përmbajë të paktën një shkronjë të madhe.",        
      "message-invalid-password-no-symbol" : "Fjalëkalimi duhet të përmbajë të paktën një simbol.",      
      "message-continue-for-commission" : "Klikoni Paguani për të përllogaritur vlerën bashkë me komision",           
      "message-payment-failed" : "Pagesa e transaksionit dështoi. Kontaktoni EasyPay për më shumë informacion.",         
      "message-payment-cancel-success" : "Pagesa e transaksionit dështoi. Paratë po ju rikthehen në kartën tuaj.",         
      "message-accounts-type-information" : "Mësoni më shumë rreth llojeve të llogarive",      
      "message-upgrade-to-ewallet": "Përfundoni regjistrimin dhe kurseni",      
      "message-invalid-city" : "Vendosni emrin e qytetit",      
      "message-invalid-address" : "Vendosni adresën",  
      "message-invalid-business-name" : "Vendosni emrin e biznesit",      
      "message-invalid-birthdate" : "Vendosni datën e lindjes",        
      "message-invalid-gender" : "Zgjidhni gjininë",      
      "message-invalid-business-name" : "Vendosni emrin e biznesit",        
      "message-invalid-terms-and-conditions" : "Ju duhet të pranoni termat dhe kushtet",      
      "message-invalid-fathers-name" : "Vendosni emrin e babait",      
      "message-invalid-user-name" : "Vendosni përdoruesin",       
      "message-invalid-amount" : "Vendosni shumën që dëshironi të dërgoni",       
      "message-invalid-change-password" : "Plotësoni fjalëkalimin",
      "message-invalid-name" : "Vendosni emrin", 
      "message-invalid-last-name" : "Vendosni mbiemrin",     
      
      //MARK: Exists
      "message-contract-exists" : "Ekziston një kontratë me këtë numër!",      
      "message-number-exists" : "Ekziston një numër i regjistruar!",     
      "message-client-code-exists" : "Ekziston një kod klienti i regjistruar!",      
      "message-car-exists" : "Ekziston një mjet me këtë targë ose shasi!",     
      "message-sc-exists" : "Ekziston një smartkartë me këtë numër!",     
      "message-installment-code-exists" : "Kodi i kredisë ekziston.",     
      "message-local-code-exists" : "Ekziston një kod vendor i regjistruar!",      
      "message-p2p-username-exists" : "Ky marrës është ruajtur një herë.",      
  
      //MARK: Biometric
      "message-activate-biometric-login" : "Dëshironi të aktivizoni hyrjen në llogari me anë të %@? Është mënyra më e shpejtë dhe e sigurt!",     
      "message-deactivate-biometric" : "Dëshironi të fshini të dhënat biometrike?",      
      "message-activate-biometric-login-cancelled" : "Nëse ndërroni mendje, mund ta aktivizoni te Më tepër -> %@",      
      "message-biometric-info" : "Duke aktivizuar %@ çdo person që ka akses në pajisje me anë të saj, mund të hyjë në llogarinë tuaj EasyPay! Ju mund të keni vetëm një llogari EasyPay me %@ aktive në pajisjen tuaj.",     
      "message-biometric-not-avaliable" : "%@ nuk është i disponueshëm ose nuk është konfiguruar!",     
      "message-biometric-not-configured" : "%@ mund të mos jetë konfiguruar!",      
      "message-biometric-not-configured-user" : "Ju nuk keni aktivizuar %@. Hyni në llogari dhe kryeni aktivizimin e të dhënave biometrike në menunë Siguria.",     
      "message-biometric-auth-failed" : "Identiteti juaj nuk mund të verifikohet!",     
      "message-biometric-login-cancelled" : "Veprimi u anullua.",     
      "message-biometric-activation-failed" : "Diçka nuk shkoi mirë me aktivizimin e %@",    
  
      //MARK: - Status
      "status-searching-debts" : "Duke kërkuar detyrimet...",       
      "status-searching-bills" : "Duke kërkuar faturat...",       
      "status-searching-penalty" : "Duke kërkuar gjobat...",       
      "status-starting-transaction" : "Duke nisur transaksionin...",      
      "status-loading-data" : "Duke ngarkuar të dhënat...",      
      "status-loading-offers" : "Duke ngarkuar ofertat...",     
      "status-loading-instances" : "Duke ngarkuar qytetet...",     
      "status-loading-products" : "Duke ngarkuar produktet...",     
      "status-loading-bill" : "Duke hapur faturën...",      
      "status-loading-debt" : "Duke hapur detyrimin...",      
      "status-loading-penalty" : "Duke hapur gjobën...",      
      "status-loading-trx" : "Duke ngarkuar transaksionet...",      
      "status-loading" : "Duke plotësuar kërkesën...",      
      "status-paying" : "Duke kryer pagesën...",      
      "status-acquiring-offer" : "Duke aktivizuar ofertën...",      
      "status-saving-data" : "Duke ruajtur të dhënat...",       
      "status-deleting-data" : "Duke fshirë...",       
      "status-loading-services" : "Duke ngarkuar shërbimet...",     
      "status-please-wait" : "Ju lutemi të prisni...",      
      "status-data-not-found" : "Nuk keni veprime të ruajtura",     
  
      //MARK: - Dialog
      "dialog-beneficiary" : "Përfituesi",      
      "dialog-transfer-sum" : "Vlera e transfertës",     
      "dialog-transferred-sum" : "Vlera e transferuar",      
      "dialog-total-sum" : "Vlera totale",      
      "dialog-trx-date" : "Data e transaksionit",      
      "dialog-trx-id" : "Trx ID",       
      "dialog-message" : "Mesazhi",       
      "dialog-contract" : "Kontrata",      
      "dialog-serie" : "Seriali",       
      "dialog-name" : "Emri",       
      "dialog-lastname" : "Mbiemri",      
      "dialog-date" : "Data",       
      "dialog-fee" : "Komisioni",      
      "dialog-gross-fee" : "Komision total",      
      "dialog-gross-amount" : "Totali",      
      "dialog-amount" : "Vlera",       
      "dialog-smartcard" : "Smartkarta",          
      "dialog-phone" : "Telefoni",        
      "dialog-product" : "Produkti",         
      "dialog-code" : "Kodi",        
      "dialog-remaining" : "Mbetur",        
      "dialog-description" : "Përshkrimi",          
      "dialog-year" : "Viti",           
      "dialog-installment" : "Kësti",         
      "dialog-installment-count" : "Numri i kësteve",          
      "dialog-loan" : "Kredia",        
      "dialog-client-code" : "Kodi i klientit",           
      "dialog-interest" : "Kamata",     
      "dialog-tv-tax" : "Taksa TV",       
      "dialog-plate" : "Targa",       
      "dialog-place" : "Vendi",     
      "dialog-owner" : "Pronari",      
      "dialog-brand" : "Marka",      
      "dialog-city" : "Qyteti",      
      "dialog-discount" : "Zbritja",          
      "dialog-subscriber" : "Abonenti",       
      "dialog-months-paid" : "Muaj të paguar",      
      "dialog-months-benefited" : "Muaj të përfituar",      
      "dialog-fee-per-tax" : "Komision për taksë",      
      "dialog-tax-count" : "Numri i taksave",       
      "dialog-bank-fee" : "Tarifa bankare",      
      "dialog-title-information" : "Informacion",      
  
      // MARK: - Placeholder
      "placeholder-user" : "Përdoruesi",      
      "placeholder-comment" : "Koment",      
      "placeholder-temp-password" : "Fjalëkalimi i përkohshëm",      
      "placeholder-email" : "e-mail",      
      "placeholder-password" : "Fjalëkalimi",      
      "placeholder-name" : "Emër Mbiemër",       
      "placeholder-address" : "Adresa",      
      "placeholder-father-name" : "Atësia",      
      "placeholder-full-name" : "Emër Atësi Mbiemër",      
      "placeholder-birthday" : "Datëlindja dd/mm/vvvv",      
      "placeholder-expiry-date" : "Data e skadencës",     
      "placeholder-phone" : "6########",      
      "placeholder-personal-no" : "Numri personal i ID",    
      "placeholder-subject-name" : "Emri i subjektit",      
      "placeholder-city" : "Qyteti",     
      "placeholder-client-code" : "Kodi i klientit",      
      "placeholder-loan-code" : "Kodi i kredisë",       
      "placeholder-local-code" : "Kodi vendor",      
      "placeholder-nuis" : "NIPT-i",     
      "placeholder-amount" : "Vlera",         
      "placeholder-beneficiary-comment" : "Mesazh për marrësin (opsional)",          
      "placeholder-subscriber-number" : "Numri i abonentit",           
      "placeholder-contract" : "Kontrata",          
      "placeholder-phone-number" : "Numri i telefonit",       
      "placeholder-serie" : "Vendosni serialin",        
      "placeholder-number" : "Numri",        
      "placeholder-smartcard" : "Vendosni numrin e smartkartës",          
      "placeholder-administrator" : "Administratori",      
      "placeholder-document-number" : "Vendosni numrin e dokumentit",         
      "placeholder-old-password" : "Fjalëkalimi i vjetër",      
      "placeholder-new-password" : "Fjalëkalimi i ri",      
      "placeholder-confirm-password" : "Konfirmo fjalëkalimin",     
      "placeholder-choose-product" : "Zgjidh produktin",      
      "placeholder-gender" : "Gjinia",      
      "placeholder-customer-name" : "Emri i kontratës",      
      "placeholder-clear-filter" : "Fshini filtrimin",      
      "placeholder-country" : "Shteti",      
      "placeholder-marathon-type" : "Lloji i maratonës",  
      "placeholder-marathon-registration-type" : "Lloji i regjistrimit",     
      "placeholder-registration-2" : "Emri i institucionit",     
      "placeholder-registration-3" : "Emri i fondacionit",      
      "placeholder-registration-4" : "Emri i kompanisë",      
      "placeholder-registration-5" : "Emri i skuadrës",      
      "placeholder-marathon-shirt-size" : "Masa e bluzës",      
      "placeholder-student-id-number" : "Numri i kartës studentore",      
      "placeholder-student-id" : "Foto e kartës studentore",      
      "placeholder-personal-data" : "Të dhënat personale",      
      "placeholder-security" : "Siguria",       
      "placeholder-notification" : "Njoftimet",      
      "placeholder-help-support" : "Ndihmë dhe suport",      
      "placeholder-full-name" : "Emër Atësi Mbiemër",      
      "placeholder-full-name-basic" : "Emër Mbiemër",      
      "placeholder-help-support-footer" : "Ndihmë!",       
      "placeholder-contact-footer" : "Kontakte",          
      "placeholder-fees-limits" : "Tarifat dhe Limitet",          
      "placeholder-user-p2p" : "Përdoruesi i marrësit",      
      "placeholder-utility-amount" : "Vendosni vlerën e rimbushjes",       
      "placeholder-utility-number" : "6########",          
      "placeholder-utility-plate" : "Vendosni targën e mjetit",          
      "placeholder-utility-chase" : "Vendosni shasinë e mjetit",          
      "placeholder-utility-client-number" : "Vendosni numrin e abonentit",          
      "placeholder-client-code" : "Vendosni kodin e klientit",        
      "placeholder-amount" : "Vendosni vlerën", 
      "placeholder-choose-number": "Zgjidh Numrin",       
      "placeholder-search-city": "Kërko qytetin",
      "placeholder-enter-amount": "Vendos shumën",

      //MARK: - Other
      "visa" : "Visa",
      "mastercard" : "Mastercard",
      "gender-male" : "Mashkull",       
      "gender-female" : "Femër",       
      "legal-person" : "Person juridik",        
      "physical-person" : "Person fizik",        
      "and-separator" : "dhe",       
      "or-separator" : "ose",       
      "password-rules-beginning" : "Fjalëkalimi duhet të përmbajë",  
      "password-rules-length" :  "6 karaktere",    
      "password-rules-uppercase" : "një shkronjë të madhe",        
      "password-rules-lowercase" : "një shkronjë të vogël",     
      "password-rules-number" : "një numër",       
      "password-rules-symbol" : "një simbol",        
      "account-type-basic" : "Llogari ekspres",         
      "account-type-eWallet" : "Llogari personale",          
      "account-type-business" : "Llogari biznesi",           
      "face-id" : "'Face ID'",           
      "touch-id" : "'Touch ID'",             
      "currency" : "Lekë",          
      "car-plate" : "Targa",           
      "car-chase" : "Shasia",          
      "terms-conditions" : "f kushtet",          
      "personal-no-format" : "A00000000A",            
      "nuis-format" : "A00000000A",            
      "app-version" : "Version:   %@",             
      "push-notifications" : "Push Notifications",           
      "no-commission" : "pa komision",           
      "days" : "Ditë",           
      "hours" : "Orë",         
      "minutes" : "Minuta",            
      "seconds" : "Sekonda",         
      "question" : "Pyetje",        
      "answer" : "Përgjigje",           
      "all" : "Të gjitha",         
      "terms-and-conditions-confirm" : "Konfirmoj qe i kam lexuar dhe pranoj",            
      "terms-and-conditions": "Termat dhe Kushtet",         
      "of-ep": " e EasyPay" ,
      "openingBalance": "Balanca Hyrëse",
      "closingBalance": "Balanca Dalëse", 
      "date": "Data",
      "transId": "Transaksioni",
      "serial": "Seriali", 
      "channel": "Kanali",
      "type": "Tipi",
      "productName": "Emri",
      "show-me-how" : "Më trego si",
      "contacts" : "Kontaktet:",
      "OTT-user" : "Përdoruesi OTT",
      "number" : "Numri",
      "serial-number" : "Numri serial",
      "travel-health" : " Shëndeti në udhëtim",
      "local-obligations" : "Detyrime Vendore",
      "nationality" : "Kombësia",
      "albanian" : "Shqiptare",
      "other" : "Tjetër",
      "yes" : "Po",
      "no" : "Jo",
      "income" : "Profesioni",
      "job/savings/rent" : "Puna / Kursime / Qera / Tjetër..",
      "street/building/apartment" : "Rruga / Ndërtesa / Apartamenti",
      "europian" : "Europiane",
      "american" : "Amerikane",
      "secondary-address" : "Adresa Sekondare",
      "tax-number" : "TIN: Tax Identification Number",
      "try-again" : "Provoni përsëri",
      "ID" : "Kartë Identiteti",
      "passport" : "Pashaportë",
      "choose-id-or-passport" : "Zgjidhni nëse do skanoni kartën e identitetit apo pashaportën",
      "statistics" : "Statistikat",
      "id-number": "Numër ID",
  
      //MARK: Favorites
      "fav-smartcard" : "smartkartën",        
      "fav-car" : "mjetin",          
      "fav-contract" : "kontratën",          
      "fav-client-code" : "kodin e klientit",         
      "fav-local-code" : "kodin vendor",         
      "fav-loan-code" : "kodin e kredisë",            
      "fav-beneficiary" : "marrësin",            
      "fav-phone-number" : "numrin",            
   
      //MARK: Config
      "language" : "Shqip",           
      "intro-url" : "https://www.easypay.al/MobileLogos/Videos/intro.mp4",                
      "date-format" : "dd/MM/yyyy",           
      "full-date-format" : "dd/MM/yyyy HH:mm:ss",            
  
      "message-no-favorite" : "Ruani shërbimet apo llojet e veprimeve që kryeni me EasyPay.",                  
      "message-no-transaction" : "Ju nuk keni kryer ende veprime me EasyPay",           
      "title-new" : "Të rejat",         
      "prompt-start-now" : "Fillo tani",      
      "prompt-logout" : "Dilni nga llogaria",          
      "prompt-save-favorite" : "Shto të preferuara",   
      
       //MARK: Info
       "invite-friend-steps" : "Brenda 28 ditësh, miqtë tuaj duhet të:",
       "invite-friend-step1" : "Përdorin kodin unik kur regjistrohen",  
       "invite-friend-substep1" : "Të verifikojnë llogarinë e tyre të EasyPay",  
       "invite-friend-step2" : "Rimbushin llogarinë e tyre të EasyPay",  
       "invite-friend-substep2" : "Me kartë ose transfertë bankare",  
       "invite-friend-step3" : "Kryejnë 2 pagesa me EasyPay wallet",  
       "invite-friend-substep3" : "Për cilindo nga shërbimet e ofruara",
       "win-500": "500 ALL per ju dhe mikun tuaj!",
       "getting-paid": "Lekët do ju shtohen në e-wallet, 5 ditë pasi miku juaj të ketë kryer gjithë hapat me sukses.",  
       "info-no-ref": "Ju nuk keni referuar ende asnje mik.",
       "no-ref-p1": "Ftoni miqte tuaj ne EasyPay dhe  fitoni  500 ALL per cdo referim te suksesshem.",
       "no-ref-p2": "Sa më shumë miq të ftoni, aq më shumë perfitoni ju dhe ata!",
       "service-refused": "Kryeni të paktën një rimbushje dhe dy pagesa për të përdorur shërbimin.",
       "service-refused-msg": "Mos i lini miqte te presin",
       "refered-friend-title": "Ndiq hapat dhe fito 500 ALL !",
       "refered-friend-subtitle": "28 ditë nga marrja e kodit, ju duhet të:",
       "refered-friend-p1": "Rimbushin llogarinë tuaj EasyPay",
       "refered-friend-p2": "Kryeni 2 pagesa me EasyPay wallet",
       "info-enter-code": "Vendosni kodin me të cilin ju kanë referuar për të përfituar 500 ALL pasi keni verifikuar llogarinë dhe keni kryer dy pagesa!",
       "info-share-code": "Shpërndaje kodin duke përdorur një nga rrjetet sociale më poshtë:",
       "IaF-question-1": "Si te referosh nje mik me sukses?",
       "IaF-answer-1": "Sa me shume miq te ftosh ne EasyPay, aq me shume mund te fitoni ju dhe ata se bashku! Fito 500 ALL per cdo mik qe referohet me sukses nga ju.",
       "IaF-question-2": "Nje referim quhet i suksesshem kur:",
       "IaF-success-1": "Miku juaj ka perdorur kodin tuaj unik te referimit gjate regjistrimit",
       "IaF-success-2": "Ka rimbushur llogarine e tij te EasyPay.",
       "IaF-success-3.1": "Ka kryer te pakten 2",
       "IaF-success-3.2": "me EasyPay deri ne daten e caktuar.",
       "IaF-success-info": "Gjithashtu, cdo mik qe ju ftoni ne EasyPay do te perfitoj 500 ALL ne portofolin e tij elektronik, qe mund ti perdor si fonde drejt pageseva te ndryshme me EasyPay. Sa me shume miq te ftoni, aq me shume  perfitoni ju dhe ata!",
       "IaF-details-1": "Ju mund te ftoni sa miq te doni ne te njejten kohe, pa limit!",
       "IaF-details-2": "Do te fitoni 500 ALL per cdo mik, nese referimi eshte plotesisht i suksesshem.",
       "IaF-details-3": "Një referim është i suksesshëm kur miku juaj ka përmbushur gjithë hapat brenda afatit kohor.",
       "IaF-details-4": "Krediti do të shfaqet automatikisht në llogarinë tuaj dhe të mikut tuaj të EasyPay. Ju mund ti përdorni lekët për shërbime apo pagesa të ndryshme.",
       "more-info": "Per me shume informacion dhe detaje per programin, na kontaktoni tek",
       "IaF-dashboard": "Përfito 500 ALL \n EasyPay kredit për çdo referim të suksesshëm!",
       "IaF-dashboard-refered": "Kryej 2 pagesa për të përfituar 500 ALL EasyPay kredit.",
      }
});

